import { isVerboseUploadEnabled } from "@/Utils/verboseUploadLog";

/**
 * Suppress all console output when running against prod API (VUE_APP_API_ENV=prod).
 * Must be imported first in main.js so Vue and other libs see noops.
 *
 * Exception: when verbose upload logging is on (?verbose_upload=true), leave the
 * console intact so those diagnostics reach the console in production. The prod
 * build's terser `drop_console` has already stripped every other literal
 * `console.x()` call from the bundle, so this doesn't reintroduce general noise —
 * only the (indirectly-called) verbose upload logs remain. See verboseUploadLog.js.
 */
if (process.env.VUE_APP_API_ENV === "prod" && !isVerboseUploadEnabled()) {
  const noop = () => {};
  const methods = ["log", "info", "warn", "error", "debug", "trace"];
  methods.forEach((m) => {
    if (typeof console[m] === "function") {
      console[m] = noop;
    }
  });
  if (typeof window !== "undefined") {
    const stub = { ...console };
    methods.forEach((m) => {
      stub[m] = noop;
    });
    window.console = stub;
  }
}
